
const LoadingSpinner = (process) => {
  return eval(process)();
}

const id = "loadingIndicatorFrame"

function show() {
  document.getElementById(id).hidden = false
}

function hide() {
  document.getElementById(id).hidden = true;
}

export default LoadingSpinner